import {
    EntityEnum, getEntityEnumDescription,
} from '@c2b/muven-commons';

interface AuditMuvenApiRequest {
    [key: string]: any;
}

interface AuditMuvenApiResponse {
    [key: string]: any;
}

export class AuditMuvenApiModel {
    _id?: string = undefined;
    entity: string;
    request: AuditMuvenApiRequest = {};
    response: AuditMuvenApiResponse = {};
    date: Date | string | undefined = undefined;
    loadingListAction: boolean = false;

    constructor(a?: Partial<AuditMuvenApiModel>) {
        Object.assign(this, a);
        delete (this as any).isStatusSuccess;
        delete (this as any).isStatusError;
        delete (this as any).isStatusWarning;

        this._parseEntity()
        this._parseDate();
    }

    getEntity():string {
        if (!this.entity) {
            return ''
        }

        return this.entity
    }

    getStatus():number {
        if (!this.response?.status) {
            return -1
        }

        return this.response.status
    }

    isStatusSuccess():boolean {
        return this.getStatus() >= 200 && 
            this.getStatus() < 400
    }

    isStatusError():boolean {
        return !this.isStatusSuccess() &&
            !this.isStatusWarning()
    }

    isStatusWarning():boolean {
        return this.getStatus() >= 400 &&
            this.getStatus() < 500
    }

    getRequestCall():string {
        if (!this.request?.url) {
            return ''
        }

        return `${this.request.method} ${this.request.url}`
    }

    private _parseEntity():void {
        if (!this.request?.url) {
            return
        }

        if (/order|pedido|fatura/.test(this.request.url)) {
            this.entity = getEntityEnumDescription(EntityEnum.Order)
            return
        }

        if (/product|produto|sku/.test(this.request.url)) {
            this.entity = getEntityEnumDescription(EntityEnum.Product)
            return
        }

        if (/categor/.test(this.request.url)) {
            this.entity = getEntityEnumDescription(EntityEnum.Category)
            return
        }

        if (/brand|marca/.test(this.request.url)) {
            this.entity = getEntityEnumDescription(EntityEnum.Brand)
            return
        }

        if (/hook/.test(this.request.url)) {
            this.entity = 'Webhook'
            return
        }

        if (/pessoa|customer|client/.test(this.request.url)) {
            this.entity = 'Cliente'
            return
        }
    }

    private _parseDate():void {
        if (typeof this.date !== "string") {
            return;
        }

        this.date = new Date(this.date);
    }
}
